// GSS-360 — Multi-role permissions + grouped sidebar menu

// Sidebar sections grouped by department
export const SIDEBAR_SECTIONS = [
  {
    id: 'command-center',
    label: 'Centre de commandement',
    roles: ['dg', 'admin', 'cos', 'superviseur_general', 'superviseur_assistant', 'controleur', 'operateur_tsv', 'operateur_supervision'],
    items: [
      { path: '/', icon: 'command_center', label: 'Vue 360\u00B0', end: true },
      { path: '/sites', icon: 'monitoring', label: 'Monitoring temps reel' },
      { path: '/incidents', icon: 'incidents', label: 'Incidents & Alertes' },
      { path: '/commandement', icon: 'monitoring', label: 'Salle de commandement', roles: ['dg', 'admin', 'operateur_supervision', 'superviseur_general', 'cos'] },
    ],
  },
  {
    id: 'operations',
    label: 'Operations terrain',
    roles: ['dg', 'admin', 'cos', 'superviseur_general', 'superviseur_assistant', 'controleur'],
    items: [
      { path: '/agents', icon: 'agents', label: 'Agents' },
      { path: '/rondes', icon: 'rondes', label: 'Rondes & Patrouilles' },
      { path: '/controleur', icon: 'controleur', label: 'Controle terrain' },
      { path: '/vehicules', icon: 'vehicules', label: 'Vehicules' },
      { path: '/equipements', icon: 'equipements', label: 'Equipement / Materiel' },
      // ⓘ Retiree du menu le 03/09/2026 le temps d'ecrire la route backend
      //    (l'ecran existait et ne pouvait rien enregistrer), REMISE le meme
      //    jour une fois /cynophile ecrite et eprouvee (15 controles locaux).
      { path: '/cynophile', icon: 'cynophile', label: 'Cynophile (Maitres-chiens)' },
    ],
  },
  {
    id: 'rh',
    label: 'Ressources humaines',
    roles: ['dg', 'admin', 'rh', 'assistante_direction'],
    items: [
      { path: '/agents-rh', icon: 'agents', label: 'Fiches du personnel' },
      // Ecrire un cran fixe un salaire plancher : meme perimetre que la paie.
      { path: '/classement-agents', icon: 'agents', label: 'Classement des agents' },
      // ⚠️ Reviser une grille fixe le salaire de toute une categorie : roles
      //    IDENTIQUES a `canRevisser` cote API (admin, dg, rh). Le groupe RH
      //    inclut `assistante_direction`, qui n'a RIEN a faire ici — d'ou des
      //    roles PROPRES a l'item. Sans eux, le menu afficherait un ecran que le
      //    serveur refuserait en 403.
      { path: '/revision-grille', icon: 'agents', label: 'Révision de la grille', roles: ['admin', 'dg', 'rh'] },
      /* ⛔ « PERSONNEL ADMINISTRATIF » A ETE RETIRE LE 18/10/2026, et c est une
       *    decision de Dom. L ecran lisait `gladiator_sec.personnel_admin`, une
       *    table MORTE : **zero ligne en production**, mesure le 18/10. Il
       *    affichait donc une liste vide, ou — pire — la liste des agents, en
       *    laissant croire a une seconde population geree a part.
       * ➡️ CE QUE LE BESOIN ETAIT VRAIMENT : distinguer les populations. Cela se
       *    fait desormais par le FILTRE « Toutes populations » de l ecran
       *    « Fiches du personnel », alimente par les populations DECLAREES du
       *    tenant. *Une population ne se devine pas d un ecran separe : elle se
       *    declare, et le filtre la lit.*
       * ⓘ Le retrait de la TABLE est un lot a part, apres preuve de 0 lecture. */
      // ⚠️ L'ecran porte DEUX boutons gardes separement : « etat du personnel »
      //    (admin/dg/rh) et « etat de la masse salariale » (dg/comptable
      //    SEULS). Le comptable n'est PAS dans les roles de ce groupe de menu :
      //    l'entree est donc listee ici ET ci-dessous pour la comptabilite.
      /* ⚠️ ROLES PROPRES A L ENTREE — file 47, 16/09/2026. Sans eux, l entree
       *    heritait de la section RH, donc s affichait a `assistante_direction`,
       *    qui ne peut appeler AUCUNE des trois routes de cet ecran :
       *      /etats/personnel       admin, dg, rh
       *      /etats/effectifs       admin, dg, rh, comptable
       *      /etats/masse-salariale dg, comptable   (decision du 03/09, reconfirmee le 16/09)
       *    Elle ouvrait donc une page vide. ⓘ « un utilisateur ne voit que
       *    l entree dont il peut appeler la route ; s il n a aucune des trois,
       *    il n a pas d entree — pas une entree qui rend une page vide » (Dom).
       * ⓘ La liste est l UNION des roles qui atteignent au moins une route DANS
       *   CETTE SECTION. `comptable` n en fait pas partie : il n est pas dans la
       *   section RH, et son acces passe par la seconde occurrence de cette
       *   meme entree, plus bas, qui porte deja ses propres roles.
       * ⛔ AUCUNE GARDE SERVEUR N EST ELARGIE POUR FAIRE TENIR L ECRAN :
       *   l ecran suit le serveur, jamais l inverse. */
      { path: '/etats-personnel', icon: 'agents', label: 'Etats du personnel', roles: ['admin', 'dg', 'rh'] },
      { path: '/contrats-travail', icon: 'contrats', label: 'Contrats de travail' },
      { path: '/formations', icon: 'formations', label: 'Formations' },
      { path: '/planning', icon: 'planning', label: 'Planning mensuel' },
      { path: '/pointage', icon: 'pointage', label: 'Pointage journalier' },
      { path: '/conges', icon: 'conges', label: 'Permissions & Conges' },
      { path: '/paie', icon: 'paie', label: 'Paie & Bulletins' },
      /* ⚠️ ROLES PROPRES A L ENTREE — file 117, 08/10/2026. La section RH
       *    inclut `assistante_direction`, qui n a AUCUNE des routes de cet
       *    ecran : sans ces roles, elle ouvrirait une page vide.
       * ⓘ LES TROIS ROLES QUI ATTEIGNENT L ECRAN, et leur perimetre y differe :
       *   `dg` et `admin` LISENT ET ECRIVENT · `rh` LIT SEULEMENT (arbitrage de
       *   Dom). L ecran n affiche pas les boutons d ecriture a `rh` — ABSENTS,
       *   pas grises (regle 26 : le produit n explique pas ses restrictions).
       * ⛔ L ECRAN SUIT LE SERVEUR : `admin, dg` en ecriture dans
       *   `populationRoutes.js`, et c est la route qui tranche, pas ce fichier. */
      { path: '/parametrage-paie', icon: 'paie', label: 'Paramétrage de la paie', roles: ['dg', 'admin', 'rh'] },
      { path: '/postes', icon: 'postes', label: 'Gestion des postes' },
      { path: '/organigramme', icon: 'organigramme', label: 'Organigramme' },
    ],
  },
  {
    id: 'finance',
    label: 'Comptabilite & Finance',
    roles: ['dg', 'admin', 'comptable', 'responsable_commercial'],
    subGroups: [
      {
        label: 'Commercial',
        items: [
          { path: '/clients', icon: 'clients', label: 'Clients (CRM)', roles: ['dg', 'admin', 'comptable', 'responsable_commercial'] },
          { path: '/devis', icon: 'devis', label: 'Devis', roles: ['dg', 'admin', 'comptable', 'responsable_commercial'] },
          { path: '/facturation', icon: 'facturation', label: 'Facturation', roles: ['dg', 'admin', 'comptable'] },
          { path: '/encaissements', icon: 'encaissements', label: 'Encaissements', roles: ['dg', 'admin', 'comptable'] },
          // ⚠️ Le COMPTABLE atteint l'ecran des etats par ici : il est le seul,
          //    avec le DG, a pouvoir editer l'etat de la MASSE SALARIALE, et il
          //    n'appartient pas au groupe « Ressources humaines ».
          //    Sur cet ecran il ne verra QUE son bouton — l'etat nominatif sans
          //    montant ne lui est pas propose, et la route le refuserait (403).
          { path: '/etats-personnel', icon: 'agents', label: 'Etats du personnel', roles: ['dg', 'admin', 'comptable'] },
        ],
      },
      {
        label: 'Tresorerie',
        roles: ['dg', 'admin', 'comptable'],
        items: [
          { path: '/tresorerie', icon: 'tresorerie', label: 'Caisse & Banque' },
          { path: '/previsions-tresorerie', icon: 'previsions', label: 'Previsions tresorerie' },
        ],
      },
      {
        label: 'Charges',
        roles: ['dg', 'admin', 'comptable'],
        items: [
          { path: '/fournisseurs', icon: 'fournisseurs', label: 'Fournisseurs' },
          { path: '/charges', icon: 'charges', label: 'Charges & Depenses' },
          { path: '/paie-sociale', icon: 'paie_sociale', label: 'Paie & Charges sociales' },
        ],
      },
      {
        label: 'Comptabilite Generale',
        roles: ['dg', 'admin', 'comptable'],
        items: [
          { path: '/plan-comptable', icon: 'plan_comptable', label: 'Plan comptable' },
          { path: '/journaux', icon: 'journaux', label: 'Journaux comptables' },
          { path: '/grand-livre', icon: 'grand_livre', label: 'Grand livre' },
          { path: '/balance', icon: 'balance_icon', label: 'Balance generale' },
          { path: '/immobilisations', icon: 'immobilisations_icon', label: 'Immobilisations' },
          { path: '/exercices', icon: 'exercices_icon', label: 'Exercices comptables' },
          { path: '/export-fec', icon: 'export_fec', label: 'Export FEC' },
        ],
      },
      {
        label: 'Analyse',
        roles: ['dg', 'admin', 'comptable'],
        items: [
          { path: '/compte-resultat', icon: 'compte_resultat', label: 'Compte de resultat' },
          { path: '/bilan', icon: 'bilan', label: 'Bilan comptable' },
          { path: '/flux-tresorerie', icon: 'flux', label: 'Flux de tresorerie' },
          { path: '/ratios', icon: 'ratios', label: 'Ratios financiers' },
          { path: '/marge-dg', icon: 'compte_resultat', label: 'Marge & Rentabilite', roles: ['dg', 'admin'] },
          { path: '/budget', icon: 'budget', label: 'Budget & Previsions' },
          { path: '/export-comptable', icon: 'export', label: 'Export comptable' },
        ],
      },
    ],
  },
  {
    id: 'commerce-tsv',
    label: 'Commerce & TSV',
    roles: ['dg', 'admin', 'responsable_commercial'],
    items: [
      { path: '/catalogue', icon: 'catalogue', label: 'Catalogue produits' },
      { path: '/commerce', icon: 'commerce', label: 'Commerce & Stock' },
      { path: '/telesurveillance', icon: 'telesurveillance', label: 'Telesurveillance' },
      { path: '/journal-veille', icon: 'journal', label: 'Journal de veille' },
      { path: '/alarmes', icon: 'alarmes', label: 'Alarmes' },
      { path: '/contrats-prestation', icon: 'contrat_prestation', label: 'Contrats prestation' },
      { path: '/offres', icon: 'offres', label: 'Offres commerciales' },
    ],
  },
  {
    id: 'audit-deploiement',
    label: 'Audit & Déploiement',
    roles: ['dg', 'admin', 'cos', 'superviseur_general'],
    items: [
      { path: '/audit/nouveau', icon: 'audit', label: 'Nouvel audit' },
      { path: '/audit/liste', icon: 'audits', label: 'Audits en cours' },
      { path: '/audit/plans', icon: 'plan', label: 'Plans de prévention' },
      { path: '/audit/decharges', icon: 'decharge', label: 'Décharges signées' },
    ],
  },
  {
    id: 'assistanat',
    label: 'Assistanat Direction',
    roles: ['dg', 'admin', 'assistante_direction'],
    items: [
      { path: '/agenda-dg', icon: 'agenda', label: 'Agenda DG' },
      { path: '/courriers', icon: 'courriers', label: 'Courriers' },
      { path: '/comptes-rendus', icon: 'comptes_rendus', label: 'Comptes rendus' },
      { path: '/archivage', icon: 'archivage', label: 'Archivage' },
    ],
  },
  {
    id: 'intelligence-ia',
    /* ⚠️ SECTION ALIGNEE SUR LES GARDES SERVEUR — file 45, 16/09/2026.
     *    Avant ce lot : `cos, comptable, rh, assistante_direction` voyaient la
     *    section, alors que les TROIS routes derriere ses trois entrees sont
     *    `dg, admin` :
     *      /ia/assistant -> POST /chat            authorize('dg','admin')
     *      /ia/alertes   -> GET  /ia/alertes      canLireBase = ('dg','admin')
     *      /ia/rapport   -> POST /rapport-mensuel authorize('dg','admin')
     *    Quatre roles ouvraient donc une section dont chaque page repondait 403.
     * ⓘ « On ne voit que ce qu'on peut appeler. Un role qui n'a AUCUNE entree de
     *   la section n'a pas la section » (Dom). La section disparait pour eux —
     *   elle ne reste pas affichee avec des pages vides.
     * ⛔ AUCUNE GARDE SERVEUR N'EST TOUCHEE ICI : c'est le menu qui suit.
     * ⓘ Chaque entree porte SES roles, meme quand ils sont identiques a ceux de
     *   la section : le jour ou une route s'ouvrira, on modifiera l'entree qui
     *   la designe, sans avoir a relire toute la section. C'est l'heritage
     *   implicite qui a produit ce defaut. */
    label: 'Intelligence IA',
    roles: ['dg', 'admin'],
    items: [
      { path: '/ia/assistant', icon: 'ia_assistant', label: 'Assistant IA', roles: ['dg', 'admin'] },
      { path: '/ia/alertes', icon: 'ia_alertes', label: 'Alertes & règles automatiques', roles: ['dg', 'admin'] },
      { path: '/ia/rapport', icon: 'ia_rapport', label: 'Rapport IA mensuel', roles: ['dg', 'admin'] },
    ],
  },
  {
    id: 'admin',
    label: 'Administration',
    roles: ['dg', 'admin'],
    items: [
      { path: '/utilisateurs', icon: 'utilisateurs', label: 'Utilisateurs & Roles' },
      { path: '/validations', icon: 'validations', label: 'Validations' },
      { path: '/logs-audit', icon: 'logs', label: "Logs d'audit" },
      { path: '/import-donnees', icon: 'import', label: 'Import donnees' },
      { path: '/parametres', icon: 'parametres', label: 'Parametres' },
    ],
  },
];

const ROLE_PERMISSIONS = {
  dg: {
    label: 'Directeur General',
    actions: {
      agents: ['read', 'create', 'update', 'delete'],
      clients: ['read', 'create', 'update', 'delete'],
      sites: ['read', 'create', 'update', 'delete'],
      rondes: ['read'],
      incidents: ['read', 'create', 'update', 'delete'],
      vehicules: ['read', 'create', 'update', 'delete'],
      equipements: ['read', 'create', 'update', 'delete'],
      facturation: ['read'],
      paie: ['read'],
      charges: ['read'],
      'compte-resultat': ['read'],
      'export-comptable': ['read'],
      formations: ['read', 'create', 'update', 'delete', 'validate'],
      validations: ['read', 'decide'],
      contrats: ['read', 'create'],
      utilisateurs: ['read', 'create', 'update', 'delete'],
      telesurveillance: ['read', 'create', 'update', 'delete'],
      commerce: ['read', 'create', 'update', 'delete'],
      devis: ['read', 'create', 'update', 'delete'],
    },
  },
  admin: {
    label: 'Administrateur',
    actions: {
      agents: ['read', 'create', 'update', 'delete'],
      clients: ['read', 'create', 'update', 'delete'],
      sites: ['read', 'create', 'update', 'delete'],
      rondes: ['read'],
      incidents: ['read', 'create', 'update', 'delete'],
      vehicules: ['read', 'create', 'update', 'delete'],
      equipements: ['read', 'create', 'update', 'delete'],
      facturation: ['read', 'create', 'update', 'delete'],
      paie: ['read', 'create', 'update'],
      charges: ['read', 'create', 'update', 'delete'],
      'compte-resultat': ['read'],
      'export-comptable': ['read'],
      formations: ['read', 'create', 'update', 'delete', 'validate'],
      validations: ['read', 'decide'],
      contrats: ['read', 'create'],
      utilisateurs: ['read', 'create', 'update', 'delete'],
      telesurveillance: ['read', 'create', 'update', 'delete'],
      commerce: ['read', 'create', 'update', 'delete'],
      devis: ['read', 'create', 'update', 'delete'],
    },
  },
  assistante_direction: {
    label: 'Assistante de Direction',
    actions: {
      /* Creer un agent est un acte RH — decision de Dom, 16/09/2026.
       * Creer et supprimer exigent le meme niveau : une personne creee entre
       * dans la paie, dans les declarations sociales et dans les documents
       * legaux. Une fonction qui peut faire entrer quelqu un sans pouvoir l en
       * sortir est une asymetrie a l envers. L action « create » est retiree ici.
       * La ROUTE refuse aussi (autoriserActe) : ce retrait fait disparaitre le
       * bouton, il ne cache pas une porte restee ouverte. */
      agents: ['read', 'update'],
      formations: ['read', 'create', 'update', 'validate'],
      validations: ['read', 'decide'],
      contrats: ['read', 'create'],
    },
  },
  rh: {
    label: 'Responsable RH',
    actions: {
      agents: ['read', 'create', 'update', 'delete'],
      formations: ['read', 'create', 'update', 'delete', 'validate'],
      validations: ['read', 'decide'],
      contrats: ['read', 'create'],
      utilisateurs: ['read'],
    },
  },
  comptable: {
    label: 'Comptable',
    actions: {
      clients: ['read'],
      vehicules: ['read'],
      equipements: ['read'],
      devis: ['read', 'create', 'update', 'delete'],
      facturation: ['read', 'create', 'update', 'delete'],
      paie: ['read', 'create', 'update'],
      charges: ['read', 'create', 'update', 'delete'],
      'compte-resultat': ['read'],
      'export-comptable': ['read'],
      validations: ['read', 'decide'],
    },
  },
  cos: {
    label: 'Chef Operations Securite',
    actions: {
      agents: ['read'],
      clients: ['read', 'create', 'update', 'delete'],
      sites: ['read', 'create', 'update', 'delete'],
      rondes: ['read', 'create', 'update', 'delete'],
      incidents: ['read', 'create', 'update', 'delete'],
      vehicules: ['read', 'create', 'update', 'delete'],
      equipements: ['read', 'create', 'update', 'delete'],
      formations: ['read'],
      validations: ['read', 'decide'],
      telesurveillance: ['read', 'create', 'update', 'delete'],
    },
  },
  superviseur_general: {
    label: 'Superviseur General',
    actions: {
      /* Creer un agent est un acte RH — decision de Dom, 16/09/2026.
       * Creer et supprimer exigent le meme niveau : une personne creee entre
       * dans la paie, dans les declarations sociales et dans les documents
       * legaux. Une fonction qui peut faire entrer quelqu un sans pouvoir l en
       * sortir est une asymetrie a l envers. L action « create » est retiree ici.
       * La ROUTE refuse aussi (autoriserActe) : ce retrait fait disparaitre le
       * bouton, il ne cache pas une porte restee ouverte. */
      agents: ['read', 'update'],
      sites: ['read'],
      rondes: ['read', 'create', 'update', 'delete'],
      incidents: ['read', 'create', 'update'],
      vehicules: ['read'],
      equipements: ['read'],
      formations: ['read', 'validate'],
      validations: ['read', 'decide'],
    },
  },
  superviseur_assistant: {
    label: 'Superviseur Assistant',
    actions: {
      agents: ['read'],
      sites: ['read'],
      rondes: ['read', 'create', 'update'],
      incidents: ['read', 'create'],
      formations: ['read'],
    },
  },
  controleur: {
    label: 'Controleur',
    actions: {
      sites: ['read'],
      rondes: ['read', 'create', 'update'],
      incidents: ['read', 'create'],
      controleur: ['read', 'create', 'update', 'delete'],
    },
  },
  operateur_tsv: {
    label: 'Operateur Telesurveillance',
    actions: {
      telesurveillance: ['read', 'create', 'update'],
    },
  },
  operateur_supervision: {
    label: 'Operateur Supervision',
    actions: {
      sites: ['read'],
      incidents: ['read', 'create'],
      rondes: ['read'],
    },
  },
  responsable_commercial: {
    label: 'Responsable Commercial',
    actions: {
      commerce: ['read', 'create', 'update', 'delete'],
      devis: ['read', 'create', 'update', 'delete'],
      clients: ['read'],
    },
  },
};

// Normalize roles input: accepts string, array, or undefined
function normalizeRoles(roles) {
  if (!roles) return [];
  if (typeof roles === 'string') return [roles];
  return roles;
}

// Get merged permissions for multiple roles
export function getRolePermissions(roles) {
  const arr = normalizeRoles(roles);
  if (arr.length === 0) return { label: 'Utilisateur', actions: {} };
  if (arr.length === 1) return ROLE_PERMISSIONS[arr[0]] || { label: 'Utilisateur', actions: {} };

  // Merge: combine labels and union all actions
  const labels = arr.map(r => ROLE_PERMISSIONS[r]?.label).filter(Boolean);
  const merged = { label: labels.join(' / '), actions: {} };
  for (const r of arr) {
    const perms = ROLE_PERMISSIONS[r];
    if (!perms) continue;
    for (const [mod, actions] of Object.entries(perms.actions)) {
      if (!merged.actions[mod]) merged.actions[mod] = [];
      for (const a of actions) {
        if (!merged.actions[mod].includes(a)) merged.actions[mod].push(a);
      }
    }
  }
  return merged;
}

// Get the first allowed path for a set of roles (for home redirect)
export function getDefaultPath(roles) {
  const arr = normalizeRoles(roles);
  for (const section of SIDEBAR_SECTIONS) {
    if (!arr.some(r => section.roles.includes(r))) continue;
    if (section.subGroups) {
      for (const sg of section.subGroups) {
        if (sg.roles && !arr.some(r => sg.roles.includes(r))) continue;
        const first = sg.items.find(it => !it.roles || arr.some(r => it.roles.includes(r)));
        if (first) return first.path;
      }
    } else {
      const first = section.items.find(it => !it.roles || arr.some(r => it.roles.includes(r)));
      if (first) return first.path;
    }
  }
  return '/';
}

export function canAccessSection(roles, sectionId) {
  const arr = normalizeRoles(roles);
  const section = SIDEBAR_SECTIONS.find(s => s.id === sectionId);
  if (!section) return false;
  return arr.some(r => section.roles.includes(r));
}

export function canAccessNav(roles, path) {
  const arr = normalizeRoles(roles);
  for (const section of SIDEBAR_SECTIONS) {
    if (!arr.some(r => section.roles.includes(r))) continue;
    if (section.subGroups) {
      for (const sg of section.subGroups) {
        if (sg.roles && !arr.some(r => sg.roles.includes(r))) continue;
        for (const item of sg.items) {
          if (item.path === path) {
            if (item.roles && !arr.some(r => item.roles.includes(r))) return false;
            return true;
          }
        }
      }
    } else {
      for (const item of section.items) {
        if (item.path === path) {
          if (item.roles && !arr.some(r => item.roles.includes(r))) return false;
          return true;
        }
      }
    }
  }
  return false;
}

export function canAction(roles, module, action) {
  const perms = getRolePermissions(roles);
  return perms.actions[module]?.includes(action) || false;
}

// Strict priority order + display labels for badge
const ROLE_PRIORITY = [
  { key: 'admin', badge: 'ADMINISTRATEUR' },
  { key: 'dg', badge: 'DIRECTEUR GENERAL' },
  { key: 'cos', badge: 'CHEF DES OPERATIONS' },
  { key: 'rh', badge: 'RESPONSABLE RH' },
  { key: 'assistante_direction', badge: 'ASSISTANTE DIRECTION' },
  { key: 'comptable', badge: 'COMPTABLE' },
  { key: 'responsable_commercial', badge: 'COMMERCIAL' },
  { key: 'operateur_tsv', badge: 'OPERATEUR TSV' },
  { key: 'operateur_supervision', badge: 'OPERATEUR SUPERVISION' },
  { key: 'superviseur_general', badge: 'SUPERVISEUR' },
  { key: 'superviseur_assistant', badge: 'SUPERVISEUR' },
  { key: 'controleur', badge: 'CONTROLEUR' },
];

// Get the primary (highest priority) role key
export function getPrimaryRole(roles) {
  const arr = normalizeRoles(roles);
  for (const { key } of ROLE_PRIORITY) {
    if (arr.includes(key)) return key;
  }
  return arr[0] || 'controleur';
}

// Get the single badge label for the highest priority role
export function getPrimaryRoleBadge(roles) {
  const arr = normalizeRoles(roles);
  for (const { key, badge } of ROLE_PRIORITY) {
    if (arr.includes(key)) return badge;
  }
  return 'UTILISATEUR';
}

export default ROLE_PERMISSIONS;
